






























import Vue from 'vue';
import {Component, Prop, Watch, Emit} from 'vue-property-decorator';

@Component
export default class RemoveItemDialog extends Vue {
  @Prop({default: false}) readonly shown!: boolean;
  @Prop({default: ''}) readonly title!: string;
  @Prop({default: ''}) readonly message!: string;

  @Emit('confirmed')
  emitConfirmed() {
    return true;
  }

  @Emit('closed')
  emitClosed() {
    return true;
  }
}
